export function track(event: String, params?: any) {
  const heap = (window as any).heap;
  if (heap) {
    heap.track(event, params);
  }
}
